<div class="p-2">
  <mat-card appearance="outlined" class="main-panel rounded-md" data-test="announcement-card">
    <mat-card-title>Announcements & Notifications</mat-card-title>
    <mat-card-subtitle class="dashboard-subheading">
      Important information related to your account
    </mat-card-subtitle>

    <mat-card-content>
      @if (messages$ | async; as messages) {
        @for (message of messages | slice:0:3; track message) {
          <div
            class="notification-item"
            [ngClass]="message.severity"
            data-test="notification-item"
          >
            <div class="notification-icon">
              <fa-icon [icon]="getIcon(message.severity)" size="lg"></fa-icon>
            </div>

            <div class="notification-body">
              <div class="notification-header">
                <span class="title" data-test="notification-title">
                  {{ message.title }}

                  <span 
                    class="scope-badge"
                    [ngClass]="message.scope"
                    data-test="notification-scope-badge">
                    {{ message.scope === 'global' ? 'Global announcement' : 'Personal' }}
                  </span>
                </span>
                 <span class="date" data-test="notification-date">{{ message.sentTime && (message.sentTime | relativeTime) }}</span>
              </div>

              <markdown class="detail" data-test="notification-detail" [data]="message.detail.length > 450 ? (message.detail | slice:0:450) + '...' : message.detail"></markdown>

              @if (message.detail.length > 450) {
                <div class="view-details-container">
                  <button mat-button color="primary" data-test="notification-view-details-btn" (click)="viewMore()">View Details</button>
                </div>
              }
              
            </div>
          </div>
        }

        <!-- View More button -->
        @if (messages.length > 3) {
          <div class="view-more-container mt-2">
            <button mat-button color="primary" data-test="announcement-view-more-btn" (click)="viewMore()">View more</button>
          </div>
        }
      } @else {
        <div class="announcement-empty" data-test="announcement-empty-state">
          There are currently no messages or alerts.
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>